import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const SelectLanguages = () => {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState("en"); 

  useEffect(() => {
    const storedLang = localStorage.getItem("lang");

    if (storedLang) {
      i18n.changeLanguage(storedLang);
      setLang(storedLang);
    } else {
      i18n.changeLanguage("en");
      localStorage.setItem("lang", "en");
    }
  }, []);

  const handleChange = (value) => {
    setLang(value);
    i18n.changeLanguage(value);
    localStorage.setItem("lang", value);
  };

  return (
    <Select onValueChange={handleChange} value={lang}>
      <SelectTrigger
        className="bg-[#e7ebf0] px-md py-[17px] rounded-3xl"
        aria-label={t("interview.select_language")}
      >
        <SelectValue placeholder={t("interview.select_language")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">English</SelectItem>
        <SelectItem value="ar">العربية</SelectItem>
        <SelectItem value="gr">German</SelectItem>
      </SelectContent>
    </Select>
  );
};

export default SelectLanguages;
